import React from 'react';
import styled from 'styled-components';
import { styles } from '@sdir/sds';

type WhiteBoxProps = {
  children: any;
  reactIcon: any;
  iconIncluded?: boolean;
  className?: string;
};

const CardWithIcon: React.FC<WhiteBoxProps> = ({
  iconIncluded = false,
  className = '',
  children,
  reactIcon,
}) => {
  return (
    <WhiteInfoBoxComp className={className} iconIncluded={iconIncluded}>
      <Circle>{reactIcon}</Circle>
      {children}
    </WhiteInfoBoxComp>
  );
};

const WhiteInfoBoxComp = styled.div<{ iconIncluded: boolean }>`
  width: 100%;
  margin: 2em 0;
  padding: 1.5em 1.5em 0 1.5em;
  background-color: ${styles.colors.background.secondary};
  border-radius: ${styles.card.borderRadius};
  box-shadow: ${styles.card.boxShadow};
  display: flex;
`;

const Circle = styled.span`
  border-radius: 50%;
  background-color: ${styles.colors.primary};
  width: 128px;
  height: 128px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1.5em 1.5em 0;
  flex-shrink: 0;
  flex-grow: 0;
`;

export default CardWithIcon;
